export default __webpack_public_path__ + "static/media/carte-avant-2001.fdc516d3.png";